// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../../reason/next/Next.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationPageConversation = require("./ConversationPageConversation.bs.js");
var ConversationPageSelectedConversationHeader = require("./ConversationPageSelectedConversationHeader.bs.js");
var ConversationPageSelectedConversationContext = require("./ConversationPageSelectedConversationContext.bs.js");
var ConversationPageSelectedConversationMatches = require("./ConversationPageSelectedConversationMatches.bs.js");
var ConversationPageSelectedConversationAnonymousControl = require("./ConversationPageSelectedConversationAnonymousControl.bs.js");
var ConversationPageSelectedConversationDisplayer_conversation_graphql = require("../../../__generated__/ConversationPageSelectedConversationDisplayer_conversation_graphql.bs.js");

var convertFragment = ConversationPageSelectedConversationDisplayer_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationDisplayer_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationDisplayer_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationDisplayer_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationDisplayer_conversation_graphql.node, convertFragment, fRef);
}

var ConversationFragment_conversationVisibilityV5_decode = ConversationPageSelectedConversationDisplayer_conversation_graphql.Utils.conversationVisibilityV5_decode;

var ConversationFragment_conversationVisibilityV5_fromString = ConversationPageSelectedConversationDisplayer_conversation_graphql.Utils.conversationVisibilityV5_fromString;

var ConversationFragment = {
  conversationVisibilityV5_decode: ConversationFragment_conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: ConversationFragment_conversationVisibilityV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageSelectedConversationDisplayer(props) {
  var conversation = use(props.conversation);
  var router = Next.useRouter();
  var match = conversation.conversationContext;
  var tmp;
  if (match !== undefined) {
    var fragmentRefs = match.fragmentRefs;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(ConversationPageSelectedConversationContext.make, {
                        conversationContext: fragmentRefs
                      })
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(ConversationPageSelectedConversationMatches.make, {
                        conversationContext: fragmentRefs
                      })
                })
          ]
        });
  } else {
    tmp = null;
  }
  var match$1 = conversation.visibility;
  var tmp$1;
  tmp$1 = match$1 !== undefined && (match$1 === "PRIVATE" || match$1 === "PUBLIC") && match$1 !== "PRIVATE" ? JsxRuntime.jsx("div", {
          children: "This conversation is public.",
          className: "border bg-amber-50 p-4 mx-4"
        }) : null;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                    icon: "ArrowLeft",
                                    className: "inline-block",
                                    size: 16
                                  }),
                              className: "lg:hidden p-2",
                              type: "button",
                              onClick: (function (param) {
                                  Next.Router.replace("/conversations", undefined, undefined, router);
                                })
                            }),
                        JsxRuntime.jsx(ConversationPageSelectedConversationHeader.make, {
                              conversation: conversation.fragmentRefs
                            })
                      ],
                      className: "bg-gray-100 lg:bg-transparent p-4 lg:p-0 border-b lg:border-b-0 flex flex-row space-x-2 items-center"
                    }),
                tmp,
                tmp$1,
                JsxRuntime.jsx(ConversationPageSelectedConversationAnonymousControl.make, {
                      conversation: conversation.fragmentRefs,
                      conversationId: conversation.id
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ConversationPageConversation.make, {
                            conversation: conversation.fragmentRefs
                          })
                    })
              ],
              className: "lg:p-4 flex flex-col space-y-4"
            });
}

var make = ConversationPageSelectedConversationDisplayer;

exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* Next Not a pure module */
